import logger from "./log"

function spawnNotification(title, description = null, icon = null) {
  const options = {
    body: description || "",
    icon: icon
  };
  const n = new Notification(title, options);
}

function notify(title, description = null, icon = null) {
  if (!("Notification" in window)) {
    logger.warning("This browser does not support desktop notification");
    return;
  }

  if (Notification.permission === "granted") {
    spawnNotification(title, description, icon);
  } else if (Notification.permission !== "denied") {
    Notification.requestPermission((permission) => {
      if (permission === "granted") {
        spawnNotification(title, description, icon);
      }
    });
  }
}

function checkPermissions() {
  if (!("Notification" in window)) {
    logger.warning("This browser does not support desktop notification");
    return;
  }

  if (Notification.permission === "granted") {
    return;
  }

  if (Notification.permission !== "denied") {
    Notification.requestPermission();
  }
}

notify.checkPermissions = checkPermissions;
export default notify;
